export const SET_JOBSCREENING_JOBS = 'SET_JOBSCREENING_JOBS';
export const SET_JOBSCREENING_LOADING = 'SET_JOBSCREENING_LOADING ';
